const translations = {
  title: "Notifications",
  subtitle: "Operational alerts that need attention across the ERP.",
  refresh: "Refresh",
  mark_all_read: "Mark all read",
  all: "All",
  unread: "Unread",
  updated: "Updated",
  empty_title: "Everything is up to date",
  no_unread_title: "No unread notifications",
  empty_description: "New operational alerts will appear here automatically.",
  severity_info: "Info",
  severity_warning: "Warning",
  severity_critical: "Critical",
  gold_rate_title: "Gold rate is not configured",
  gold_rate_description: "Set the current gold rate before creating priced transactions.",
  license_title: "License attention required",
  license_trial: "The application is running in its configured trial period.",
  license_expired: "The configured license has expired.",
  license_suspended: "The configured license has been suspended. Contact your provider.",
  sync_conflict_title: "Data conflicts need review",
  sync_conflict_description: "{count} synchronization conflict(s) require a decision.",
  sync_pending_title: "Changes are waiting to sync",
  sync_pending_description: "{count} local change(s) are queued for cloud synchronization.",
  communication_failed_title: "Messages could not be delivered",
  communication_failed_description: "{count} message(s) exhausted all retry attempts.",
  communication_pending_title: "Messages are waiting for delivery",
  communication_pending_description: "{count} message(s) are queued for automatic retry.",
  approval_title: "Approval request pending",
  approval_description: "{type}: {reason}",
};

export default translations;
